// extracted by mini-css-extract-plugin
module.exports = {"container":"Disliked_container__pmYgr","checkbox":"Disliked_checkbox__xiVEH","feedback":"Disliked_feedback__HYjsv"};